import classNames from 'classnames'
import React from 'react'
import U from '../Utils'
import './TableVariazioni.css'

function TableVariazioni(props) {
  const { filters, series, table_data, year_bounds } = props

  const { first_year, last_year } = year_bounds
  const from = filters.from || last_year
  const to = filters.to || last_year

  return (
    <table
      className={classNames({
        TableVariazioni: true,
        table: true,
        'table-condensed': series.length > 1,
      })}
    >
      <thead>
        <tr>
          <th />
          <th className="text-right">{to}</th>
          {from !== to && [
            <th key="0" className="text-right">
              Var. % / {from}
            </th>,
            <th key="1" className="text-right">
              Var. / {from}
            </th>,
          ]}
          {from === to &&
            to > first_year && [
              <th key="0" className="text-right">
                Var. % / {to - 1}
              </th>,
              <th key="1" className="text-right">
                Var. / {to - 1}
              </th>,
            ]}
        </tr>
      </thead>
      <tbody>
        {table_data.map((row, r) => (
          <tr key={r}>
            <td>{row.lbl}</td>
            <td className="text-right">
              {series.map((ser, s) => (
                <div key={s} className={'serie' + ser.suf}>
                  {U.formatNumber(row['val' + ser.suf])}
                </div>
              ))}
            </td>
            {(from !== to || to > first_year) && [
              <td key="0" className="text-right">
                {series.map((ser, s) => (
                  <div key={s} className={'serie' + ser.suf}>
                    {U.formatNumberPlus(row['perc' + ser.suf])}%
                  </div>
                ))}
              </td>,
              <td key="1" className="text-right">
                {series.map((ser, s) => (
                  <div key={s} className={'serie' + ser.suf}>
                    {U.formatNumberPlus(row['diff' + ser.suf])}
                  </div>
                ))}
              </td>,
            ]}
          </tr>
        ))}
      </tbody>
    </table>
  )
}

export default TableVariazioni



// WEBPACK FOOTER //
// ./src/main/TableVariazioni.js